import clsx from 'clsx';
import { MarkupPreview, Checkbox } from '@nula/core-ui';
import {
  DocumentEmptyIllustration,
  CanvasEmptyIllustration,
} from '@/components/empty-illustrations';
import { hasPreviewContent } from './has-preview-content';
import styles from './library-table.module.css';

interface MiniPageCardProps {
  previewMarkup?: string | null;
  previewKind?: 'html' | 'svg' | null;
  kind?: string;
  isSelected?: boolean;
  isSelecting?: boolean;
  onToggleSelect?: () => void;
}

/** The empty-state illustration for a mini card, by entity kind. */
function MiniEmptyIllustration({ kind }: { kind?: string }) {
  if (kind === 'canvas') {
    return (
      <div className={styles.miniCardFallback} data-testid="canvas-empty-illustration">
        <CanvasEmptyIllustration className={styles.miniIllustration} />
      </div>
    );
  }
  return (
    <div className={styles.miniCardFallback} data-testid="document-empty-illustration">
      <DocumentEmptyIllustration className={styles.miniIllustration} />
    </div>
  );
}

export function MiniPageCard({ previewMarkup, previewKind, kind, isSelected, isSelecting, onToggleSelect }: MiniPageCardProps) {
  return (
    <div className={styles.miniCard}>
      {hasPreviewContent(previewMarkup) && previewKind ? (
        <div className={styles.miniCardPreview}>
          <MarkupPreview markup={previewMarkup as string} scale={0.10} />
        </div>
      ) : (
        <MiniEmptyIllustration kind={kind} />
      )}
      {onToggleSelect && (
        <div className={clsx(styles.miniCardCheckbox, (isSelecting || isSelected) && styles.miniCardCheckboxVisible)}>
          <Checkbox
            checked={!!isSelected}
            onChange={onToggleSelect}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            round
          />
        </div>
      )}
    </div>
  );
}
